import React, { FC } from 'react';
import { useFormState, Input } from 'informed';
import cn from 'classnames';
import lodash from 'lodash';
import css from './styles.module.scss';

export interface ITextField {
  name: string;
  multistepName?: string;
  label?: string | JSX.Element;
  placeholder?: string;
  type?: string;
  className?: string;
  labelClassName?: string;
  errorClassName?: string;
  initialValue?: string;
  disabled?: boolean;
  validate?: (value: unknown, values: Record<string, unknown>) => unknown;
  onChange?: (value: unknown) => void;
  onBlur?: (value: unknown) => unknown;
  validateOnBlur?: boolean;
  formatter?: Array<string | RegExp>;
  mask?: (value: string) => string;
  min?: string;
  max?: string;
}

const TextField: FC<ITextField> = ({
  name,
  multistepName,
  className,
  labelClassName,
  errorClassName,
  label,
  ...rest
}) => {
  const { errors } = useFormState();
  const error = lodash.get(errors, multistepName ? `${multistepName}.${name}` : name);

  return (
    <>
      {label && (
        <label htmlFor={name} className={cn(labelClassName, css.label)}>
          {label}
        </label>
      )}
      <Input
        {...rest}
        className={cn(css.field, className, { fieldError: error })}
        name={name}
        validateOn="blur"
        showErrorIfTouched={false}
      />
      {error ? <p className={cn(errorClassName, css.error)}>{error as string}</p> : null}
    </>
  );
};

export default TextField;
